<template>
    <v-container
        fluid
        class="mt-0 pt-0"
    >
        <v-card outlined>
            <v-form 
                ref="form" 
                v-model="valid" 
                :lazy-validation="lazy"
            >
                <v-card-title>Generales del proyecto</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                v-model="tituloInvestigacion"
                                label="Tìtulo de la Investigación *"
                                :loading="loading || loadingProp"
                                :rules="[(v) => !!v || 'Campo obligatorio']"
                                required
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                @change="fnSetValue('generalesProyecto', 'tituloInvestigacion', tituloInvestigacion)"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col
                            cols="12"
                            class="text-center"
                        >
                            <label style="color:rgba(0, 0, 0, 0.6);">
                                ¿La investigación se realiza dentro de la institución? *
                            </label>
                            <div class="flex-center">
                                <v-radio-group
                                    v-model="proyectoInstitucional"
                                    row
                                    class="justify-center"
                                    required
                                    :rules="[(v) => v != null || 'Campo obligatorio']"
                                    :readonly="!(idAccion == 1 || idAccion == 2)"
                                    @change="fnSetValue('generalesProyecto', 'proyectoInstitucional', proyectoInstitucional)"
                                >
                                    <v-layout>
                                        <v-flex>
                                            <v-radio :value="true">
                                                <template v-slot:label>
                                                    <div>Si</div>
                                                </template>
                                            </v-radio>
                                        </v-flex>

                                        <v-flex>
                                            <v-radio :value="false">
                                                <template v-slot:label>
                                                    <div>No</div>
                                                </template>
                                            </v-radio>
                                        </v-flex>
                                    </v-layout>
                                </v-radio-group>
                            </div>
                        </v-col>
                    </v-row>

                    <!-- <v-row v-if="proyectoInstitucional == false"> -->
                    <v-row v-if="false">
                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                v-model="insProponeInvestigacion"
                                label="Institución que propone la Investigación *"
                                :loading="loading || loadingProp"
                                :rules="[(v) => !!v || 'Campo obligatorio']"
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                required
                                @change="fnSetValue('generalesProyecto', 'insProponeInvestigacion', insProponeInvestigacion)"
                            />
                        </v-col>
                    </v-row>
                    
                    <v-row v-if="proyectoInstitucional == true">
                        <v-col
                            cols="12"
                            md="4"
                        >
                            <select-campus
                                :id-campus-prop="obj.idCampus"
                                etiqueta="Campus en el que se realiza la Investigación"
                                :fn-change="fnChangeCampus"
                                :requerido="true"
                                :edit="idAccion == 1 || idAccion == 2"
                                :loading-prop="loading || loadingProp"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="4"
                        >
                            <select-division
                                :id-campus="obj.idCampus"
                                :id-division-prop="obj.idDivision"
                                etiqueta="División en la que se realiza la Investigación"
                                :fn-change="fnChangeDivision"
                                :requerido="true"
                                :edit="idAccion == 1 || idAccion == 2"
                                :loading-prop="loading || loadingProp"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="4"
                        >
                            <select-departamento
                                :id-division="obj.idDivision"
                                :id-departamento-prop="obj.idDepartamento"
                                etiqueta="Departamento en el que se realiza la Investigación"
                                :fn-change="fnChangeDepartamento"
                                :requerido="true"
                                :edit="idAccion == 1 || idAccion == 2"
                                :loading-prop="loading || loadingProp"
                            />
                        </v-col>
                    </v-row>

                    <v-row v-if="proyectoInstitucional == false">
                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                v-model="lugarRealizaInvestigacion"
                                label="¿En dónde se realiza la investigación? *"
                                :loading="loading || loadingProp"
                                :rules="[(v) => !!v || 'Campo obligatorio']"
                                required
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                @change="fnSetValue('generalesProyecto', 'lugarRealizaInvestigacion', lugarRealizaInvestigacion)"
                            />
                        </v-col>
                    </v-row>



                    <v-row>
                        <v-col
                            cols="12"
                            md="6"
                        >
                            <select-tipo-investigacion
                                :id-tipo-investigacion-prop="obj.idTipoInvestigacion"
                                :fn-change="fnChangeTipoInvestigacion"
                                :requerido="true"
                                :edit="idAccion == 1 || idAccion == 2"
                                :loading-prop="loading || loadingProp"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="6"
                        >
                            <select-area
                                :id-area-prop="obj.idArea"
                                :fn-change="fnChangeArea"
                                :requerido="true"
                                :edit="idAccion == 1 || idAccion == 2"
                                :loading-prop="loading || loadingProp"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col
                            cols="12"
                        >
                            <select-disciplina
                                :id-area="obj.idArea"
                                :obj-disciplina-prop="obj.objDisciplina"
                                :fn-change="fnChangeDisciplina"
                                :requerido="true"
                                :edit="idAccion == 1 || idAccion == 2" 
                                :loading-prop="loading || loadingProp"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col
                            cols="12"
                        >
                            <v-combobox
                                v-model="palabras"
                                :label="'Palabras clave' + ((idAccion == 1 || idAccion == 2) ? ' (Presione ENTER despues de escribir cada palabra para agregarla)' : '')"
                                multiple
                                chips
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                @change="fnSetValue('generalesProyecto', 'palabras', palabras)"
                            >
                                <template v-slot:selection="{ attrs, item, select, selected }">
                                    <v-chip
                                        v-bind="attrs"
                                        :input-value="selected"
                                        :close="idAccion == 1 || idAccion == 2"
                                        @click="select"
                                        @click:close="removeItemPalabras(item)"
                                    >
                                        <span>{{ item }}</span>
                                    </v-chip>
                                </template>
                            </v-combobox>
                        </v-col>
                    </v-row>
                    
                    <!--  <v-row>
                        <v-col
                            cols="12"
                            md="6"
                        >
                            <v-textarea
                                v-model="riesgosInvestigacion"
                                label="Riesgos de la Investigación *"
                                auto-grow
                                rows="1"
                                :loading="loading || loadingProp"
                                :rules="[(v) => !!v || 'Campo obligatorio']"
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                required
                                @change="fnSetValue('generalesProyecto', 'riesgosInvestigacion', riesgosInvestigacion)"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="6"
                        >
                            <v-textarea
                                v-model="beneficiosInvestigacion"
                                label="Beneficios de la Investigación *"
                                placeholder="¿Cuáles fueron los beneficios obtenidos en la investigación?"
                                auto-grow
                                rows="1"
                                :loading="loading || loadingProp"
                                :rules="[(v) => !!v || 'Campo obligatorio']"
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                required
                                @change="fnSetValue('generalesProyecto', 'beneficiosInvestigacion', beneficiosInvestigacion)"
                            />
                        </v-col>
                    </v-row> -->

                    <v-row>
                        <v-col
                            cols="12"
                        >
                            <v-textarea
                                v-model="resumenInvestigacion"
                                label="Resumen de la Investigación *"
                                auto-grow
                                rows="1"
                                :loading="loading || loadingProp"
                                :rules="[(v) => !!v || 'Campo obligatorio', (v) => v.trim().split(' ').length <= 500 || 'Máximo 500 palabras']"
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                required
                                counter="500"
                                :counter-value="v => v.trim().split(' ').length"
                                hint="Número máximo de palabras: 500"
                                @change="fnSetValue('generalesProyecto', 'resumenInvestigacion', resumenInvestigacion)"
                            />
                        </v-col>
                    </v-row>

                    <!--        <v-row>
                        <v-col
                            cols="12"
                            class="text-center"
                        >
                            <label style="color:rgba(0, 0, 0, 0.6);">
                                Se considera entregar consentimiento informado al participante en original: *
                            </label>
                            <div class="flex-center">
                                <v-radio-group
                                    v-model="consentimiento"
                                    row
                                    class="justify-center"
                                    required
                                    :rules="[(v) => v != null || 'Campo obligatorio']"
                                    :readonly="!(idAccion == 1 || idAccion == 2)"
                                    @change="fnSetValue('generalesProyecto', 'consentimiento', consentimiento)"
                                >
                                    <v-layout>
                                        <v-flex>
                                            <v-radio :value="true">
                                                <template v-slot:label>
                                                    <div>Si</div>
                                                </template>
                                            </v-radio>
                                        </v-flex>

                                        <v-flex>
                                            <v-radio :value="false">
                                                <template v-slot:label>
                                                    <div>No</div>
                                                </template>
                                            </v-radio>
                                        </v-flex>
                                    </v-layout>
                                </v-radio-group>
                            </div>
                        </v-col>
                    </v-row> -->
                    
                    <v-row>
                        <v-col
                            cols="12"
                        >
                            <v-textarea
                                v-model="consideracionesBioeticas"
                                label="Consideraciones éticas que debe conocer el Comité *"
                                auto-grow
                                rows="1"
                                :loading="loading || loadingProp"
                                :rules="[(v) => !!v || 'Campo obligatorio']"
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                required
                                @change="fnSetValue('generalesProyecto', 'consideracionesBioeticas', consideracionesBioeticas)"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col
                            cols="12"
                        >
                            <card-archivo-protocolo
                                :id-proyecto="idProyecto"
                                :id-accion="idAccion"
                                :file-protocolo="obj.fileProtocolo"
                                :file-id="obj.fileId"
                                :file-name="obj.fileProtocoloName"
                                :file-uuid="obj.fileUuid"
                                :file-fecha-carga="obj.fileFechaCarga"
                                :edit="idAccion == 1 || idAccion == 2"
                                :fn-change="fnChangeFileProtocolo"
                                :show-validation-error="showValidationError"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-form>

            <v-card-actions v-if="idAccion == 1 || idAccion == 2">
                <v-btn
                    rounded 
                    @click="setSectionProp({ nombre: 'Datos del proyecto', id: 'datos-del-proyecto' }, true); $refs.form.validate();"
                >
                    <v-icon left>
                        mdi-arrow-left
                    </v-icon>
                    Anterior                    
                </v-btn>
                <v-spacer />
                <v-btn
                    color="blue" 
                    rounded 
                    dark
                    @click="setSectionProp({ nombre: 'Participantes', id: 'participantes' }, true); $refs.form.validate();"
                >
                    Siguiente
                    <v-icon right>
                        mdi-arrow-right
                    </v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-snackbar
            key="snackbarFormGeneralesProyecto"
            v-model="snackbar"
            :bottom="true"
            :multi-line="true"
            :color="snackbarColor"
        >
            {{ snackbarTexto }}
            <v-btn
                dark
                text
                @click="snackbar = false;"
            >
                Cerrar
            </v-btn>
        </v-snackbar> 
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "FormGeneralesProyecto",
  components: {
    SelectTipoInvestigacion: () => import("../../compartidos/SelectTipoInvestigacion"),
    SelectArea: () => import("../../compartidos/SelectArea"),
    SelectDisciplina: () => import("../../compartidos/SelectDisciplina"),
    CardArchivoProtocolo: () => import("../../compartidos/CardArchivoProtocolo"),
    SelectCampus: () => import("../../compartidos/SelectCampus"),
    SelectDivision: () => import("../../compartidos/SelectDivision"),
    SelectDepartamento: () => import("../../compartidos/SelectDepartamento"),
  },
  props: {
    idProyecto: {
      type: Number,
      required: true
    },
    idAccion: {
      type: Number,
      required: true,
    },
    obj: {
        type: Object,
        required: true
    },
    loadingProp: {
        type: Boolean,
        default: false
    },
    fnSetValue: {
        type: Function,
        default: () => 1,
    },
    banValidarForm: {
        type: Number,
        default: 0
    },
    updateValidForms: {
        type: Function,
        default: () => 1,
    },
    setSectionProp: {
        type: Function,
        default: () => 1,
    }
  },
  data () {
    return {
      tituloInvestigacion: '',
      insProponeInvestigacion: '',
      proyectoInstitucional: null,
      idTipoInvestigacion: null,
      idArea: null,
      objDisciplina: null,      
      palabras: [],
      riesgosInvestigacion: '',
      beneficiosInvestigacion: '',
      resumenInvestigacion: '',
      consideracionesBioeticas: '',
      lugarRealizaInvestigacion: '',
      consentimiento: null,
      fileProtocolo: null,
      fileUuid: '',

      showValidationError: false,

      loading: false,
      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',

      valid: false,
      lazy: false,
    };
  },
  computed: {
      ...mapGetters("oidc", ["oidcUser"]),
      fileProtocoloo () {
        return this.obj.fileProtocolo;
      },
      fileProtocoloName () {
        return this.obj.fileProtocoloName;
      }
   },
  watch: {
    banValidarForm: {
        handler (newValue, oldValue) {
            this.fnValidarFormulario();
        },
    },
/*     obj: {
        handler (newValue, oldValue) {
            var valido = this.valid && ((newValue.fileProtocolo != null && newValue.fileProtocolo != undefined) || (newValue.fileProtocoloName != '' && newValue.fileProtocoloName != null))
            this.updateValidForms(2, valido);
        },
        deep: true,
        immediate: true 
    }, */
    valid: {
        handler (newValue, oldValue) {
            this.fnValidarFormulario();
        },
    },
    fileProtocoloo: {
        handler (newValue, oldValue) {
            this.fnValidarFormulario();
        },
    }, 
    fileProtocoloName: {
        handler (newValue, oldValue) {
            this.fnValidarFormulario();
        },
    }, 
  },
  async mounted () {
      this.fnSetValuesProp();
  },
  methods: {
      fnValidarFormulario () {
          this.showValidationError = true;
          if (this.valid && ((this.obj.fileProtocolo != null && this.obj.fileProtocolo != undefined) || (this.obj.fileProtocoloName != '' && this.obj.fileProtocoloName != null))) {
              this.updateValidForms(2, true);
          }
          else{
              this.updateValidForms(2, false);
          }
      },
      fnSetValuesProp () {
          this.loading = true;
          this.tituloInvestigacion = this.obj.tituloInvestigacion == null ? '' : this.obj.tituloInvestigacion;
          this.insProponeInvestigacion = this.obj.insProponeInvestigacion == null ? '' : this.obj.insProponeInvestigacion;
          this.proyectoInstitucional = this.obj.proyectoInstitucional;
          this.idCampus = this.obj.idCampus;
          this.idDivision = this.obj.idDivision;
          this.idDepartamento = this.obj.idDepartamento;
          this.lugarRealizaInvestigacion = this.obj.lugarRealizaInvestigacion;

          this.idTipoInvestigacion = this.obj.idTipoInvestigacion;
          this.idArea = this.obj.idArea;
          this.objDisciplina = this.obj.objDisciplina;
          this.palabras = this.obj.palabras;
          this.riesgosInvestigacion = this.obj.riesgosInvestigacion == null ? '' : this.obj.riesgosInvestigacion;
          this.beneficiosInvestigacion = this.obj.beneficiosInvestigacion == null ? '' : this.obj.beneficiosInvestigacion;
          this.resumenInvestigacion = this.obj.resumenInvestigacion == null ? '' : this.obj.resumenInvestigacion;
          this.consideracionesBioeticas = this.obj.consideracionesBioeticas == null ? '' : this.obj.consideracionesBioeticas;
          this.consentimiento = this.obj.consentimiento;
          this.fileProtocolo = this.obj.fileProtocolo;
          this.fileUuid = this.obj.fileUuid;

          this.showValidationError = false;
          this.$refs.form.resetValidation();

          this.loading = false;
          this.fnValidarFormulario();

      },
      fnChangeTipoInvestigacion (objTipoInv) {
          this.fnSetValue('generalesProyecto', "idTipoInvestigacion", objTipoInv.idTipoInvestigacionPk)
      },
      fnChangeArea (objArea) {
          this.fnSetValue('generalesProyecto', "idArea", objArea.idAreaPk)
      },
      fnChangeDisciplina (objDisc) {
          this.fnSetValue('generalesProyecto', "objDisciplina", objDisc)          
      },
      fnChangeFileProtocolo (file) {
          this.fnSetValue('generalesProyecto', "fileProtocolo", file)
            if(file == null) {
                this.fnSetValue('generalesProyecto', "fileUuid", '')
                this.fnSetValue('generalesProyecto', "fileId", '')
                this.fnSetValue('generalesProyecto', "fileProtocoloName", '')
                this.fnSetValue('generalesProyecto', "fileFechaCarga", '')
            }
            else{
                this.fnSetValue('generalesProyecto', "fileFechaCarga", new Date().toLocaleString())
            }
      },
      removeItemPalabras (item) {
        this.palabras.splice(this.palabras.indexOf(item), 1)
        this.palabras = [...this.palabras]
      },
      fnChangeCampus (objCampus) {
          this.fnSetValue('generalesProyecto', "idCampus", objCampus.id == null ? null : parseInt(objCampus.id))
          this.fnSetValue('generalesProyecto', "idDivision", null)
          this.fnSetValue('generalesProyecto', "idDepartamento", null)


      },
      fnChangeDivision (objDivision) {
          this.fnSetValue('generalesProyecto', "idDivision", objDivision.id)
          this.fnSetValue('generalesProyecto', "idDepartamento", null)
      },
      fnChangeDepartamento (objDepartamento) {
          this.fnSetValue('generalesProyecto', "idDepartamento", objDepartamento.id)
      },
  }
};
</script>

<style scoped>
  .flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>

<style scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  }
</style>